import React, { createContext, useEffect, useState } from 'react';

export const AuthContext = createContext();

const UserContext = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const signIn = (email, password) => {
        if (!email || !password) {
            return Promise.reject(new Error('Email and password are required.'));
        }

        const localUser = { uid: 'local-admin', email };
        localStorage.setItem('projitize_admin_user', JSON.stringify(localUser));
        setUser(localUser);
        return Promise.resolve({ user: localUser });
    }

    const userSignOut = () => {
        localStorage.removeItem('projitize_admin_user');
        setUser(null);
        return Promise.resolve();
    }

    useEffect(() => {
        const storedUser = localStorage.getItem('projitize_admin_user');
        if (storedUser) {
            try {
                setUser(JSON.parse(storedUser));
            } catch (error) {
                localStorage.removeItem('projitize_admin_user');
                setUser(null);
            }
        }
        setLoading(false);
    }, []);

    const authInfo = { user, loading, signIn, userSignOut };

    return (
        <AuthContext.Provider value={authInfo}>
            {children}
        </AuthContext.Provider>
    );
};

export default UserContext;